'use strict';

var _    = require('underscore');
var $    = require('jquery');
var Core = require('../core/core.js');

/**
 * Creates a Submenu Tool
 *
 * @class
 */

class TabSubNavTool extends Core {

	_defaults() {
		return {
			target: '.js-editor',
			fields: {
				'name': 'no name',
				'description': '',
				'icon': false,
				'weight': 0
			}
		};
	}

	constructor(options) {
		super(options);

		this.template = `
			<div class='editor__tab__subnav__tool js-editor__tab__subnav__sortable float' data-weight='<%- weight %>'>
				<a class='js-editor__tab__subnav__tool__link non-selectable mouse--action' title='<%- description %>'>
					<div class='editor__tab__subnav__tool__svg'><%= embedded_svg(icon) %></div>
				</a>
			</div>
		`;

		super.render();

		/**
		 * Click event
		 *
		 * @fires SubNavTool#_clicked
		 */

		 $('.js-editor__tab__subnav__tool__link', this.$el).on('click', this._clicked);
	}

	/**
     * @event SubNavTool#Cioui:SubNavTool:clicked
     * @property {String}Cioui:SubNavTool:clicked
     * @returns {Object} event - native click Event
     */

	_clicked(e){
		e.preventDefault();
		$(e.currentTarget).trigger('Cioui:SubNavTool:clicked', e);
	}

    /*
     * Make a tool disabled
     */
    disable(){
        this.$el.addClass('editor__tab__subnav__tool--disabled');
    }

    /*
     * Enable a tool after it has been disabled
     */
    enable(){
        this.$el.removeClass('editor__tab__subnav__tool--disabled');
    }

    /*
     * Make a tool active
     */
    active(){
        this.$el.addClass('editor__tab__subnav__tool--active');
    }

    /*
     * Enable a tool inactive
     */
    inactive(){
        this.$el.removeClass('editor__tab__subnav__tool--active');
    }

}
module.exports = TabSubNavTool;